import React, { useEffect, useState } from 'react';
import { deleteYaraRule, getYaraRules } from 'api/api_service';
import { IYaraRules } from 'types';
import ConfirmModal from 'components/confirm_modal';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import strings from '../../strings/strings.json'

interface Props {
    yaraData: Array<string>
    refreshList: () => void
}
export default function YaraList(props: Props) {
    const yaraRegex = /(?!.*\/).+/
    const dispatch = useDispatch();
    const [confirmModal, setOpenConfirmModal] = useState(false)
    const [deleteData, setDeleteData] = useState()

    const deleteHandler = (data: any) => {
        setOpenConfirmModal(true)
        setDeleteData(data)
    }

    const confirmHandler = (data: any) => {

        deleteYaraRule({
            "rule_name": data
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(showSnackbar({ "open": true, severity: "success", msg: `${strings.public_operationDone}` }));
                    setOpenConfirmModal(false)
                    props.refreshList()
                }
            })
    }

    const mapHandler = (data: any, index: number) => {
        const name = yaraRegex.exec(data)

        return (
            <div key={index} className='flex  justify-between items-center mx-10 border-b border-b-gray-200 py-3 hover:bg-gray-100'>
                <div className='flex justify-center items-center'>
                    <img className='w-4 mr-2' src={require('../../assets/icons/yara_code.svg').default} alt="Icon" />
                    <span className='primary_text_color text-xs VazirEng'>{name && name[0]}</span>
                </div>
                <div className='bg-pink-600 p-1 rounded cursor-pointer' onClick={() => deleteHandler(name && name[0])}><img className='w-4' src={require('../../assets/icons/delete.svg').default} alt="delete" /></div>
            </div>
        )
    }

    return (
        <React.Fragment>
            {props.yaraData !== undefined && props.yaraData.map(mapHandler)}
            {
                (deleteData !== undefined && confirmModal) &&
                <ConfirmModal
                    data={deleteData}
                    openModal={confirmModal}
                    onCloseModal={() => setOpenConfirmModal(false)}
                    confirmClicked={(data) => confirmHandler(data)}
                />
            }
        </React.Fragment>
    )
}
